// extracted by mini-css-extract-plugin
export var booking = "BookingWidget-module--booking--2taOx";
export var column = "BookingWidget-module--column--1TvJN";
export var thanks = "BookingWidget-module--thanks--1P-cp";
export var checkout = "BookingWidget-module--checkout--3VD70";
export var center = "BookingWidget-module--center--o9sAk";